import { useEffect, useRef, useState } from "react";
import "./StickyAgent.css";

const WHATSAPP_PHONE = "972528020693";
const WHATSAPP_MSG = "היי הייתי באתר ורציתי לדבר.";

export default function StickyAgent({ disableWhenInViewRef }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const openedOnce = useRef(false);
  const isContactInView = useRef(false);
  const timerRef = useRef(null);

  const waUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
    WHATSAPP_MSG
  )}`;

  const telUrl = `tel:+${WHATSAPP_PHONE}`;

  // ✅ כשה-ContactSection נכנס לפריים: מסתירים את ה-Agent לגמרי
  useEffect(() => {
    const el = disableWhenInViewRef?.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        const inView = entry.isIntersecting;
        isContactInView.current = inView;

        // ✅ להסתיר כשהגענו לקונטקט
        setIsHidden(inView);

        if (inView) {
          // לעצור טיימר ולסגור אם פתוח
          if (timerRef.current) clearTimeout(timerRef.current);
          setIsOpen(false);
        }
      },
      {
        threshold: 0,
        // כשהקונטקט מתקרב לתחתית המסך - כבר להסתיר
        rootMargin: "0px 0px -35% 0px",
      }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [disableWhenInViewRef]);

  // פתיחה אוטומטית אחרי 12 שניות או גלילה + 10 שניות (רק פעם אחת)
  useEffect(() => {
    if (openedOnce.current) return;

    const armTimer = () => {
      if (isContactInView.current) return;
      timerRef.current = setTimeout(() => {
        if (openedOnce.current) return;
        if (isContactInView.current) return;

        setIsOpen(true);
        openedOnce.current = true;
      }, 12000);
    };

    armTimer();

    const onScroll = () => {
      if (openedOnce.current) return;
      if (isContactInView.current) return;

      if (timerRef.current) clearTimeout(timerRef.current);
      armTimer();
      window.removeEventListener("scroll", onScroll);
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const openNow = () => {
    if (isContactInView.current) return; // לא לפתוח כשאנחנו בקונטקט
    if (!openedOnce.current) openedOnce.current = true;
    setIsOpen(true);
  };

  return (
    <div
      className={`saWrap ${isOpen ? "open" : "closed"} ${
        isHidden ? "hidden" : ""
      }`}
      dir="rtl"
      onMouseEnter={openNow}
    >
      {/* <div className="saHeader">
        <span className="saTitle">  רוצים לדבר?</span>

        {isOpen ? (
          <button
            className="saIconBtn"
            onClick={() => setIsOpen(false)}
            aria-label="סגור"
            type="button"
          >
            ✕
          </button>
        ) : (
          <button
            className="saIconBtn"
            onClick={openNow}
            aria-label="פתח"
            type="button"
          >
      <svg width="22" height="22" viewBox="0 0 847 694" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M423.053 0C656.695 0 846.106 155.239 846.106 346.74C846.106 424.805 814.628 496.847 761.506 554.794L793.956 645.271C798.15 656.966 786.723 668.21 775.097 663.827L674.201 625.791C603.962 668.332 517.088 693.479 423.053 693.479C189.411 693.479 0.000160989 538.24 0 346.739C0 155.239 189.411 0.000108147 423.053 0ZM231.695 286.477C198.414 286.477 171.434 313.457 171.434 346.738C171.434 380.02 198.414 407.001 231.695 407.001C264.977 407.001 291.958 380.02 291.958 346.738C291.958 313.457 264.977 286.477 231.695 286.477ZM423.051 286.477C389.769 286.477 362.789 313.457 362.789 346.738C362.789 380.02 389.769 407.001 423.051 407.001C456.333 407.001 483.313 380.02 483.313 346.738C483.313 313.457 456.332 286.477 423.051 286.477ZM614.41 286.477C581.129 286.477 554.149 313.457 554.148 346.738C554.148 380.02 581.129 407.001 614.41 407.001C647.692 407.001 674.673 380.02 674.673 346.738C674.673 313.457 647.692 286.477 614.41 286.477Z" fill="#1F3B51"/>
</svg>

          </button>
        )}
      </div> */}
<button
  className="saHeader saHeaderBtn"
  onClick={isOpen ? () => setIsOpen(false) : openNow}
  aria-label={isOpen ? "סגור" : "פתח"}
  type="button"
>
  <h5 className="saTitle">רוצים לדבר?</h5>

  <span className="saHeaderIcon">
    {isOpen ? (
      <span className="saClose">✕</span>
    ) : (
      <svg
        width="22"
        height="22"
        viewBox="0 0 847 694"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M423.053 0C656.695 0 846.106 155.239 846.106 346.74C846.106 424.805 814.628 496.847 761.506 554.794L793.956 645.271C798.15 656.966 786.723 668.21 775.097 663.827L674.201 625.791C603.962 668.332 517.088 693.479 423.053 693.479C189.411 693.479 0.000160989 538.24 0 346.739C0 155.239 189.411 0.000108147 423.053 0ZM231.695 286.477C198.414 286.477 171.434 313.457 171.434 346.738C171.434 380.02 198.414 407.001 231.695 407.001C264.977 407.001 291.958 380.02 291.958 346.738C291.958 313.457 264.977 286.477 231.695 286.477ZM423.051 286.477C389.769 286.477 362.789 313.457 362.789 346.738C362.789 380.02 389.769 407.001 423.051 407.001C456.333 407.001 483.313 380.02 483.313 346.738C483.313 313.457 456.332 286.477 423.051 286.477ZM614.41 286.477C581.129 286.477 554.149 313.457 554.148 346.738C554.148 380.02 581.129 407.001 614.41 407.001C647.692 407.001 674.673 380.02 674.673 346.738C674.673 313.457 647.692 286.477 614.41 286.477Z"
          fill="#1F3B51"
        />
      </svg>
    )}
  </span>
</button>

      <div className="saBody">
        <p className="">השאירו הודעה ונחזור אליכם</p>


<div  className="btns">
        <a className="saBtnPrimary mt-15" href={waUrl} target="_blank" rel="noreferrer">
          <p className="">הודעה בוואטסאפ</p>
        </a>

        {/* חיוג מהיר - רק מובייל */}
        <a className="saBtnCall mt-15 mobile-only" href={telUrl}>
          <p className="">חיוג מהיר</p>
        </a>

</div>

      </div>
    </div>
  );
}
